import { twMerge } from 'tailwind-merge';
import { SmartLink } from '@/components/SmartLink';
import type { NavigationItem } from '@/types/Navigation';

interface NavItemProps extends NavigationItem {
    active: boolean;
}

export default function NavItem({ title, url, active }: NavItemProps) {
    return (
        <li
            key={title}
            className={twMerge(
                'text-base text-haug-choco-100',
                'flex items-center',
                'whitespace-nowrap',
                'pt-[6px]',
                active ? 'border-haug-coral-100 border-b-[6px] text-haug-coral-100' : 'pb-[6px]'
            )}
        >
            <SmartLink
                href={url}
                className="flex h-full items-center px-4 py-2 font-bold font-neue-haas"
            >
                {title}
            </SmartLink>
        </li>
    );
}
